import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field_filled, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            label: "Recherche",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetSelected())),
            density: "compact",
            "append-inner-icon": "$fa-search",
            clearable: "",
            "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = ''))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        class: "pt-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            style: {"height":"27vh","overflow":"scroll"},
            lines: "two"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsList, (item) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: item.id,
                  onClick: ($event: any) => (_ctx.selectProduct(item)),
                  class: _normalizeClass(_ctx.getProductClass(item.id)),
                  style: {"border-color":"rgba(0, 0, 0, 0.12)"},
                  "data-cy": "selectInvoiceProduct-product",
                  variant: "outlined",
                  title: item.title + ' - ' + item.reference,
                  subtitle: item.unitPrice + '€ (' + item.vatRate + ' %)'
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_btn_icon, {
                      color: "primary",
                      icon: 
                                item.id === _ctx.selectedProduct.id
                                    ? '$radio_button_checked'
                                    : '$radio_button_unchecked'
                            
                    }, null, 8, ["icon"])
                  ]),
                  _: 2
                }, 1032, ["onClick", "class", "title", "subtitle"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}